<template>
 <div v-if="loaded">
   <app-price-card
       v-for="(anItem, n) in searchedResources"
       :item="anItem"
       :key="`apc-${n}`"
       @myapp-clicked="handleMyAppClick"
       @myapp-get-clicked="handleMyAppGetClick"
   />
 </div>
</template>

<script>
import AppPriceCard from "../../../components/appCard";
import {mapGetters} from "vuex";
export default {
  name: "Display_MyAppStore_Store",
  components: {
    AppPriceCard,
  },
  props: {
    userOwnedItems: {
      type: Array,
      default: () => []
    },
    shallFilterOutUserOwnedItems: {
      type: Boolean,
      default: true
    }
  },
  async created() {
     await this.getApps();
     await this.getResources();
     this.loaded = true;
  },
  mounted() {
  },
  computed: {
      ...mapGetters({
        allResources: "tools/listTools",
        apps: "user/apps",
        profile: "user/profile"
      }),
    searchedResources() {
      if (this.searchStr.trim() == "") return this.allResources;

      return this.allResources.filter(tool => {
        return tool.name
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim());
      });
    },
      filteredItems() {
        let filteredResources = this.storeItems.filter(anItem => {
          let check = true;
          this.activeTags.forEach(tag => {
            if (!anItem.tags.includes(tag.toLowerCase())) check = false;
          });
          return check;
        });
        let result = filteredResources;

        if (this.shallFilterOutUserOwnedItems) {
          result = this.filterOutUserOwnedItems(filteredResources);
        }
        return result;
      }
  },
  methods: {
    getApps() {
      this.$store.dispatch("user/getListApps").then(apps => {});
    },
    getResources() {
      this.$store.dispatch("tools/getListTools").then(apps => {});
    },
    filterOutUserOwnedItems(items) {

      let filteredItems2 = items.filter(o1 => {
        return !this.userOwnedItems.some(o2 => {
          return o1.uid === o2.uid; // assumes unique id
        });
      })
          .map(o => {
            // use reduce to make objects with only the required properties
            // and map to apply this to the filtered array as a whole
            return o;
          });
      return filteredItems2;
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidingTo) {},
    handleOpenSideBar() {
      debugger;
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    /*STORE SPECIFIC */
    handleSearchClick() {
      this.showtools = "search";
    },
    addItemInstant(anItem) {
      if (this.activeTools.length < this.maxAmtofTools) {
        //Add who is selecting it and when was it created.
        //@ToDo= get Role to say Granddaughter Kena- and nicknames
        let selectedBy = {
          uid:this.profile.userId,
          relation:'',
          name: `${this.profile.firstname} ${this.profile.lastname}`,
          imgURL: this.profile.imgURL,
          _created_at: new Date()
        };

        if (!Array.isArray(anItem.selectedBys)) anItem.selectedBys = [];
        anItem.selectedBys.push(selectedBy);
        anItem._created_at = new Date();
        this.resources.push(anItem);
        if (anItem[this.uid])
          this.activeTools.push(anItem[this.uid]);
      }
    },
    addItemOldDelete(item) {
      let itemName = item[this.name].split(",");
      let { _created_at, description, imgURL, title, toolId, toolRef } = item;
      let tooldetail = {};
      if (_created_at) tooldetail._created_at = _created_at;
      if (description) tooldetail.description = description;
      if (imgURL) tooldetail.imgURL = imgURL;

      if (toolId) tooldetail.toolId = toolId;
      if (toolRef) tooldetail.toolRef = toolRef.path;
      let itemObject = itemName
          ? {
            _created_at: new Date(),
            text: itemName[0],
            subText: itemName.length > 1 ? itemName[1] : "",
            uid: uid > -1 ? uid : undefined,
            tooldetail: tooldetail
          }
          : {};
      return itemObject;
    },
    checkIsToolOnDb(name) {
      let existingTools = this.$store.getters["user/listTools"].map(
          el => el.text
      );
      if (existingTools.includes(name)) {
        return this.$store.getters["user/listTools"][
            existingTools.indexOf(name)
            ].uid;
      } else {
        return false;
      }
    },
    toggleFilter(tag) {
      let index = this.activeTags.indexOf(tag);
      if (index >= 0) {
        this.activeTags.splice(index, 1);
      } else {
        this.activeTags.push(tag);
      }
    },
    handleMyAppClick(item) {
      this.$emit('myapp-clicked',item);

    /*  this.searchStr = "";
      let toolIndex =
          item && item[name]
              ? this.activeTools.indexOf(item[this.uid])
              : -1;
      if (toolIndex >= 0) {
        this.activeTools.splice(toolIndex, 1);
        this.resources.splice(toolIndex, 1);
      } else {
        this.activeDisplayItem = item;
        this.showtools = "display";
      }*/
    },
    handleAddThis(item) {
      //if (this.activeTools.length < 4) { //@To Do not sure why this condition was here - with no error
      if (this.activeDisplayItem && this.activeDisplayItem[this.uid])
        this.activeTools.push(this.activeDisplayItem[this.uid]);

      this.showtools = "resources";
      this.addItemInstant(item);
    },
    handleSelectedItems() {
      this.$emit("selected-items", this.resources);
      this.$bvModal.hide(this.modalId);
    },
    handleOnClose() {
      //Clear resources list
      //ToDo- give the user an option to save what they have selected before adding
      //Why do we need to arrays?
      this.resources = [];
      this.activeTools = [];
    },
  },
  data() {
    return {
      loaded: false,
      appCategories:[
        {
          _created_at:123,
          text:"(S)piritual"
        },
        {
          _created_at:123,
          text:"(H)ealth"
        },
        {
          _created_at:123,
          text:"(E)ducation"
        },
        {
          _created_at:123,
          text:"(F)inance"
        },
        {
          _created_at:123,
          text:"Recommendations"
        },
        {
          _created_at:123,
          text:"Games"
        }
      ],
      pauseSlideWithInterval: false,
      assetsURLHome: "", //assets/apps/myappstore/',
      audioDuration: null,
      sidebarId: "myapps-store-sidebar-1",
      sidebarModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "store-slides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      /*MYAPP DATA */
      maxAmtofTools: 100,
      resources: [],
      tags: ["Cognition", "Services", "Reporting"],
      activeTags: [],
      showtools: "resources", //resources, display, search
      activeTools: [],
      searchStr: "",
      activeDisplayItem: {}
    }
  }
}
</script>

<style lang="scss" scoped></style>
